export class User {
  readonly gamerTag: string
  readonly imageUrl: string
  readonly targetsHit: number | undefined
  readonly targetsSeen: number | undefined
  readonly gamesPlayed: number | undefined
  readonly totalGamePlayTimeMs: number | undefined

  constructor(
    gamerTag: string,
    imageUrl: string,
    targetsHit?: number,
    targetsSeen?: number,
    gamesPlayed?: number,
    totalGamePlayTimeInMis?: number
  ) {
    this.gamerTag = gamerTag
    this.imageUrl = imageUrl
    this.targetsHit = targetsHit
    this.targetsSeen = targetsSeen
    this.gamesPlayed = gamesPlayed
    this.totalGamePlayTimeMs = totalGamePlayTimeInMis
  }

  averageHitSpeedInMs(): string | null {
    if (this.targetsHit && this.targetsHit > 0 && this.totalGamePlayTimeMs) {
      return (this.totalGamePlayTimeMs / this.targetsHit).toFixed(2)
    } else {
      return null
    }
  }

  targetHitPercentage(): string | null {
    if (this.targetsSeen && this.targetsSeen > 0 && this.targetsHit) {
      return ((this.targetsHit / this.targetsSeen) * 100).toFixed(2)
    } else {
      return null
    }
  }
}
